import src from "IMAGE";
export default { src, width: 2443, height: 2500, blurWidth: 0, blurHeight: 0};
